<div class="row download-panel">
  <ng-container *ngFor="let productPath of packedProductPaths">
    <ng-container [ngSwitch]="productPath.type">
      <div class="col-12" *ngSwitchCase="'YATTA_PROFILES'">
        <a
          [yatExternalLink]="getUrl(productPath)"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_AFTER_SALES"
          matomoClickAction="Select_Download"
          matomoClickName="YATTA_PROFILES">
          <yat-icon id="f3dabe81-65d4-4979-9075-2d81fb0269b4" [name]="getIcon(productPath)" class="ico float-left" [multiColored]="true"></yat-icon>
          {{ getDescription(productPath) | async }}
          <yat-icon id="d93f463c-0795-4a2e-9259-5fcb8c257b96" name="arrow-down-circle-duo" class="ico float-right"></yat-icon>
        </a>
      </div>
      <div class="col-12" *ngSwitchCase="'ECLIPSE_UPDATE_SITE'">
        <a
          [yatExternalLink]="getUrl(productPath)"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_AFTER_SALES"
          matomoClickAction="Select_Download"
          matomoClickName="ECLIPSE_UPDATE_SITE">
          <yat-icon id="b98ee982-dd7a-406f-b3d0-f2e354fde251" [name]="getIcon(productPath)" class="ico float-left" [multiColored]="true"></yat-icon>
          {{ getDescription(productPath) | async }}
          <yat-icon id="02f45828-fd70-499c-bb64-8ef65df556b6" name="link-external-duo" class="ico float-right"></yat-icon>
        </a>
      </div>
      <ng-container *ngSwitchCase="'CONTAINER'">
        <div class="col-12">
          <yat-dropdown id="725943b4-261e-48e5-a30e-71f8153834f7">
            <ng-container ngProjectAs="button">
              <yat-icon id="f4b0409c-a089-456f-8acc-bd181ebe2dc8" [name]="getIcon(getProductPaths(productPath)[0])" class="ico"></yat-icon>
              {{ getDescription(getProductPaths(productPath)[0]) | async }}
            </ng-container>
            <ng-container ngProjectAs="menu">
              <ng-container *ngFor="let productPathChild of getProductPaths(productPath)">
                <a
                  class="dropdown-item item"
                  [yatExternalLink]="productPathChild.url"
                  [matomoClickCategory]="MATOMO_EVENT_CATEGORY_AFTER_SALES"
                  matomoClickAction="Select_Download"
                  [matomoClickName]="productPathChild.url">
                  <yat-icon id="abaf9165-4843-4629-b3fe-d0f8f8850f10" [name]="getIcon(productPathChild)" class="ico"></yat-icon>
                  {{ getDescription(productPathChild) | async }}
                  <yat-icon id="398fbb37-8ce5-40e5-b03f-fee3ac2f154f" name="arrow-down-circle-duo" class="ico-download"></yat-icon>
                </a>
              </ng-container>
            </ng-container>
          </yat-dropdown>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'DOWNLOAD_PAGE'">
        <div class="col-12" *ngIf="showDownloadOverviewPanel">
          <div class="item">
            <yat-icon id="88ec8979-16e1-4125-ae13-c610987f7f49" name="share-filled" class="ico float-left download-overview"></yat-icon>
            {{ getUrl(productPath) | removeUrlProtocol }}
            <div class="inline-flex float-right">
              <a
                href="mailto:?subject={{
                  'marketplace.product.downloadButtonGroup.downloadMail.subject' | transloco: { productName: this.productName }
                }}&body={{ getUrl(productPath) }}"
                class="d-inline float-right">
                <yat-icon id="d61d0d87-b884-4de1-96ce-3b84bf279b99" name="envelope" class="ico mr-0"></yat-icon>
              </a>
              <span class="delimiter"></span>
              <yat-copy-to-clipboard id="3dfad090-b55a-4db6-8193-ad035fa92887" [content]="getUrl(productPath)"></yat-copy-to-clipboard>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
